module.exports = __webpack_public_path__ + "static/media/logo-l.dc9ebcf3.png";